import React, { Component } from 'react';
import { Radio, message, Badge } from 'antd';
import { api, app } from "../../app";
import ReviewFailModal from "../../components/ReviewFailModal";
import ReIdentity from "./ReIdentity";
import ReEquipment from "./ReEquipment";
import ReSkill from "./ReSkill";
import ReHonorCode from "./ReHonorCode";
import ReTransferTeam from "./ReTransferTeam";
import ReCardLost from "./ReCardLost";
import ReOrganization from "./ReOrganization";
import ReDonation from "./ReDonation"

class ReInfo extends Component {

    constructor(props) {
        super(props);
        let tabs = [
            // { val: "2", name: "技能审核", count: 'ppe_audit_count' },
            // { val: "3", name: "装备审核", count: 'mall_audit_count' },
            // {val: "4", name: "荣誉编码审核"},
            { val: "5", name: "转队/加入 审核", count: 'team_audit_count' }, // 队管看不见看不见
            // { val: "6", name: "工作证挂失审核", count: 'lost_audit_count' },
        ], rights = app.getData("rights"), sel_tab = "2";

        if ("123".indexOf(rights) > -1) {
            tabs.unshift({ val: "1", name: "身份审核", count: 'user_audit_count' });
            sel_tab = "1";
            // if (rights === 1 || rights === 3) {
            //     // tabs.push({val: "7", name: "认证机构审核", count: 'organization_count'});
            //     tabs.push({ val: "5", name: "转队/加入 审核", count: 'team_audit_count' });
            // }
        }
        // tabs.push({ val: "8", name: "捐赠审核", count: 'donate_count' });
        this.state = {
            review_visible: false,
            reviewInfo: {},
            sel_tab: sel_tab,
            tabs: tabs,
            auditCount: {},
        };
    }
    componentDidMount() {
        this._isMounted = true;
        this.dataCountSource();
    }



    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据加载
     * @returns {Promise<void>}
     */
    dataCountSource = async () => {
        let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let { flag, data, msg } = await app.post(api.UserAuditCount, params);
        if (flag === 1) {
            this.setData({ auditCount: data });
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 审核结果
     * @param param
     * @returns {Promise<void>}
     */
    handleCheckReview = async (audit, detail, reviewInfo, other_params) => {
        app.alert('正在审核~', 'loading', '35%', 0);
        const { uri, id, id_key, source } = reviewInfo || this.state.reviewInfo;
        let params = {
            audit,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        };
        params[id_key] = id; //id
        if (audit === 2) params.detail = detail;
        if (other_params && other_params instanceof Object) params = Object.assign(params, other_params);
        const { flag, msg } = await app.post(uri, params);
        message.destroy();
        if (audit === 2) this.CloseReviewModal();
        if (flag === 1) {
            app.alert('审核成功', 'success');
            if (source) source();
            await this.dataCountSource();
            return true;
        } else {
            app.alert(msg, 'warn');
            return false;
        }
    }

    /**
     * 打开不通过审核对话框
     * @param uri
     * @param id_key
     * @param source
     * @param id
     * @constructor
     */
    OpenReviewModal = (reviewInfo) => {
        this.setData({ review_visible: true, reviewInfo });
    }

    /**
     * 关闭不通过审核对话框
     * @constructor
     */
    CloseReviewModal = () => {
        this.setData({ review_visible: false, reviewInfo: {} });

    }

    /**
     * 审核结果
     * @param rule
     * @param value
     * @param callback
     */
    handleReviewResult = (rule, value, callback) => {
        if (value && value.trim() === '') {
            callback('请输入审核失败原因！')
        }
        callback()
    }

    /**
     * Tab按钮变换
     * @param e
     */
    handleTabBtnChange = (e) => {
        const { value } = e.target;
        this.setData({ sel_tab: value });
    }

    render() {
        let { review_visible, sel_tab, tabs, auditCount } = this.state,
            zi_props = {
                successReview: this.handleCheckReview,
                failReview: this.OpenReviewModal,
            };

        let content_node = null;
        switch (sel_tab) {
            case "1":   //身份审核
                content_node = (<ReIdentity {...zi_props} />);
                break;
            case "2":   //技能审核
                content_node = (<ReSkill {...zi_props} />);
                break;
            case "3":   //装备审核
                content_node = (
                    <ReEquipment {...zi_props} />);
                break;
            case "4":   //荣誉编码审核
                content_node = (
                    <ReHonorCode {...zi_props} />);
                break;
            case "5":   //转队/加入队伍审核
                content_node = (
                    <ReTransferTeam {...zi_props} />);
                break;
            case "6":   //工作证挂失审核
                content_node = (
                    <ReCardLost {...zi_props} />);
                break;
            case "7":   //认证机构审核
                content_node = (
                    <ReOrganization {...zi_props} />);
                break;
            case "8":   //捐赠审核
                content_node = (
                    <ReDonation {...zi_props} />);
                break;
        }
        return (
            <div className="review-info">
                <div className="page-title">队员信息审核</div>
                <div className="page-content">
                    <div className="review-info-tab">
                        <Radio.Group value={sel_tab} buttonStyle="solid" onChange={this.handleTabBtnChange}>
                            {
                                tabs.map((tab, index) =>
                                    <Badge count={auditCount[tab.count] || 0} key={index}>
                                        <Radio.Button value={tab.val}
                                            className='no-select'>{tab.name}</Radio.Button>
                                    </Badge>
                                )
                            }
                        </Radio.Group>
                    </div>
                    <div className="review-info-content">
                        {content_node}
                    </div>
                    <ReviewFailModal visible={review_visible} close={this.CloseReviewModal} label={sel_tab === "3" ? "驳回原因" : "失败原因"}
                        submit={(detail) => this.handleCheckReview(2, detail)} zhu={sel_tab === "3" ? "注：审核不通过将全额退款。" : null} />
                </div>
            </div>
        );
    }
}

export default ReInfo;



// WEBPACK FOOTER //
// ./src/routes/review/ReInfo.jsx